import {
  Avatar,
  colors,
  Divider,
  Drawer,
  Hidden,
  List,
  ListSubheader, Typography, Link, InputBase
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useOktaAuth } from '@okta/okta-react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { matchPath, useLocation } from 'react-router';
import avatar from 'src/assets/images/technician.png';
import NavItem from 'src/components/NavItem';
import { getUser } from 'src/utils/Common';
import { useMailOrbitEnabled } from 'src/utils/mailorbitFeature';
import { isProduction } from 'src/utils/contants';
import HelpIcon from '@material-ui/icons/Help';
import StoreIcon from '@material-ui/icons/Store';
import ChatIcon from '@material-ui/icons/ChatOutlined';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import UnreadMenuLabel from 'src/components/MailOrbit/MyEmailWork/UnreadMenuLabel';
import DashboardIcon from '@material-ui/icons/Dashboard';
import VisibilityIcon from '@material-ui/icons/Visibility';
import FormatListBulletedIcon from '@material-ui/icons/ImportContacts';
import PersonIcon from '@material-ui/icons/PersonOutlined';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import LiveHelp from '@material-ui/icons/LiveHelp';
import { useTranslation } from 'react-i18next';
import WorkIcon from '@material-ui/icons/Work';
import BuildIcon from '@material-ui/icons/Build';
import axios from 'src/utils/axios';
import { Link as RouterLink } from 'react-router-dom';
import { sc } from 'src/utils/Common';
import { fade } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import StorefrontTwoToneIcon from '@material-ui/icons/StorefrontTwoTone';
import WorkOffIcon from '@material-ui/icons/WorkOff';
import AssignmentIcon from '@material-ui/icons/Assignment';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import StoreOutlinedIcon from '@material-ui/icons/StoreOutlined';
import ListAltIcon from '@material-ui/icons/ListAlt';
import AssignmentLateIcon from '@material-ui/icons/AssignmentLate';
import NewReleasesIcon from '@material-ui/icons/NewReleases';
import AllInboxIcon from '@material-ui/icons/AllInbox';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import PhoneIcon from '@material-ui/icons/Phone';
import MapIcon from '@material-ui/icons/Map';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  navigation: {
    overflow: 'auto',
    padding: theme.spacing(0, 2, 2, 2),
    flexGrow: 1
  },
  profile: {
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  badge: {
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`
  },
  badgeDot: {
    height: 9,
    minWidth: 9
  },
  onlineBadge: {
    backgroundColor: colors.green[600]
  },
  awayBadge: {
    backgroundColor: colors.orange[600]
  },
  busyBadge: {
    backgroundColor: colors.red[600]
  },
  offlineBadge: {
    backgroundColor: colors.grey[300]
  },
  avatar: {
    cursor: 'pointer',
    width: 40,
    height: 40
  },
  details: {
    marginLeft: theme.spacing(2)
  },
  moreButton: {
    marginLeft: 'auto',
    color: colors.blueGrey[200]
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.55),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.65),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '20ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));

function renderNavItems(
  {
    // eslint-disable-next-line react/prop-types
    items,
    subheader,
    key,
    ...rest
  },
  klima_teknisyeni
) {
  return (
    <List key={key}>
      {subheader && <ListSubheader disableSticky>{subheader}</ListSubheader>}
      {items.reduce(
        (acc, item) =>
          reduceChildRoutes({ acc, item, ...rest }, klima_teknisyeni),
        []
      )}
    </List>
  );
}

function reduceChildRoutes(
  { acc, pathname, item, depth = 0 },
  klima_teknisyeni
) {
  if (
    klima_teknisyeni &&
    item.klima_teknisyeni_gizle &&
    item.klima_teknisyeni_gizle
  ) {
    return acc;
  }
  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        key={item.href}
        label={item.label}
        open={Boolean(open)}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        key={item.href}
        label={item.label}
        title={item.title}
      />
    );
  }

  return acc;
}
const klima_teknisyeni = false;
function NavBar({ open, onClose, className, ...rest }) {
  const { t, i18n } = useTranslation(['navigation', 'mailorbitWork']);
  const classes = useStyles();
  const [Search, setSearch] = React.useState('');
  const location = useLocation();
  const SessionUser = getUser();
  const mailOrbitEnabled = useMailOrbitEnabled();
  const Menu = [
    //  {
    //      title: 'Dashboard',
    //     href: '/dashboard/dashboard',
    //     icon: DashboardIcon,
    //   },
    {
      title: t('is_emirleri'),
      href: '/overview',
      icon: WorkIcon
    },
    {
      title: t('Sales'),
      href: '/Sales',
      icon: ShoppingCartIcon

    },
    {
      title: t('SironexPayments'),
      href: '/SironexPayments',
      icon: ShoppingCartIcon

    },
    {
      title: t('ExternalSystemTasks'),
      href: '/externalsystemtasks',
      icon: ListAltIcon
    },
    ...(mailOrbitEnabled ? [{
      title: t('mailorbitWork:menu_title'),
      href: '/myemailwork',
      icon: MailOutlineIcon,
      label: UnreadMenuLabel
    }] : []),
    ...(SessionUser.IsIhpTenant ? [{
      title: t('WorkOrderUrgentCustomers'),
      href: '/WorkOrderUrgentCustomers',
      icon: NewReleasesIcon
    }] : []),
    {
      title: t('SurveyModule'),
      href: '/SurveyModule',
      icon: AssignmentLateIcon
    },
    {
      title: t('WorkOrderCargo'),
      href: '/WorkOrderCargo',
      icon: LocalShippingIcon
    },
    {
      title: t('OutboundCallActivitiesList'),
      href: '/OutboundCallActivitiesList',
      icon: PhoneIcon
    },
    ...(SessionUser.TenantId == 75 ? [{
      title: t('AreaSearch'),
      href: '/AreaSearch',
      icon: MapIcon
    }] : []),

    ...(SessionUser.TenantId != 61 ? [{
      title: t('lblMaterialOrder'),
      href: '/materialOrder2',
      icon: ShoppingCartIcon,
      items: [
        {
          title: t('lblQuery'),
          href: '/materialOrder2/Query',
          icon: AssessmentOutlinedIcon
        },
        {

          title: t('lblCreate'),
          href: '/materialOrder2/Create',
          icon: AddBoxOutlinedIcon,
          items: [
            ...(SessionUser.TenantId == 87 || SessionUser.TenantId == 16 || SessionUser.TenantId == 51 ? [{
              title: t('lblForConsumer'),
              href: '/materialOrder2/Create/ForConsumer',
              icon: PersonOutlineOutlinedIcon
            }] : []),
            ...(SessionUser.TenantId != 37 && SessionUser.TenantId != 82 && SessionUser.TenantId != 51 ? [{
              title: t('lblForPartner'),
              href: '/materialOrder2/Create/ForPartner',
              icon: StoreOutlinedIcon
            }] : []),
            ...(SessionUser.TenantId == 37 || SessionUser.TenantId == 82 || SessionUser.TenantId == 51 || SessionUser.TenantId == 59 || SessionUser.TenantId == 56 || SessionUser.TenantId == 78 ? [{
              title: t('lblForOTC'),
              href: '/materialOrder2/Create/ForOTC',
              icon: PersonOutlineOutlinedIcon
            }] : []),
          ]
        }
      ]
    }] : []),
    // {
    //   title: t('Malzeme_ihtiyacim'),
    //   href: '/overview',
    //   icon: ShoppingCartIcon,
    // },
    {
      title: t('Yorum'),
      href: '/chat',
      icon: ChatIcon
    },
    {
      title: t('Bultenler'),
      href: '/Bultenler',
      klima_teknisyeni_gizle: true,
      icon: FormatListBulletedIcon
    },
    // {
    //   title: t('Report'),
    //   href: '/overview',
    //   icon: AssessmentIcon,
    //   items: [
    //     {
    //       title: t('Report1'),
    //       icon: RiMessage2Line,
    //       href: '/overview'
    //     }
    //   ]
    // },
    // {
    //   title: t('Kullanici'),
    //   href: '/profile',
    //   icon: PersonIcon,
    //   items: [
    //     {
    //       title: t('Mesajlar'),
    //       icon: RiMessage2Line,
    //       href: '/profile/1/timeline'
    //     },
    //     {
    //       title: t('Baglanti'),
    //       icon: GoDeviceMobile,
    //       href: '/profile/1/connections'
    //     },
    //     {
    //       title: t('Koordinat'),
    //       icon: GoLocation,
    //       href: '/profile/1/Lokasyon'
    //     },
    //     {
    //       title: t('Digiport'),
    //       icon: ReportIcon,
    //       href: '/profile/1/Digiport'
    //     }
    //   ]
    // },
    {
      title: t('Kullanici'),
      href: '/profile/1/timeline',
      icon: PersonIcon
    },
    {
      title: t('TechnicalKnowledgeBase'),
      href: '/TechnicalKnowledgeBase',
      icon: LiveHelp
    },
    ...(!SessionUser.IsIhpTenant? [{
      title: t('lblWatchList'),
      href: '/WatchList',
      icon: VisibilityIcon
    }] : []),
    {
      title: t('lblCustomerFeedback'),
      href: '/CustomerFeedback',
      icon: SettingsBackupRestoreIcon
    },
    {
      title: t('lblRevenueGeneration'),
      href: '/RevenueGeneration',
      icon: AllInboxIcon
    },
    {
      title: t('lblServicePartnerContact'),
      href: '/ServicePartnerContact',
      icon: StoreIcon
    },
    // {
    //   title: t('Teknisyen Yönetimi'),
    //   href: '/TechnicianManagement',
    //   icon: BuildIcon
    // },
    // {
    //   title: t('lblServiceShopMaterial'),
    //   href: '/ServiceShopMaterial',
    //   icon: StorefrontTwoToneIcon
    // },
    // {
    //   title: t('lblServiceShopOffWork'),
    //   href: '/ServiceOffWork',
    //   icon: WorkOffIcon 
    // },
    ...(!SessionUser.IsIhpTenant ? [{
      title: t('lblServiceShopOffWork'),
      href: '/ServiceOffWork',
      icon: WorkOffIcon
    }] : []),
    ...(!SessionUser.IsIhpTenant ? [{
      title: t('Servis_iletisim'),
      href: '/ServisIletisim',
      icon: StoreIcon
    }] : []),
    ...(!SessionUser.IsIhpTenant ? [{
      title: t('lblProductRelease'),
      href: '/ProductRelease',
      icon: AssignmentIcon
    }] : []),
    ...(SessionUser.IsIhpTenant? [{
      title: t('lblPartnerReports'),
      href: '/PartnerReports',
      icon: AssessmentOutlinedIcon,
      items: [
        {
          title: t('lblTradePartnerRepairForConsumer'),
          href: '/TradePartner-RepairForConsumer',
          icon: PersonOutlineOutlinedIcon
        },
        {
          title: t('lblTradePartnerWorkOrderList'),
          href: '/TradePartner-WorkOrderList',
          icon: ListAltIcon
        }
      ]
    }] : []),
    {
      title: t('Yardim'),
      href: '/Yardim',
      icon: HelpIcon
    }
  ];

  const MenuCount = Menu.length;
  const { oktaAuth, authState } = useOktaAuth();
  const [navConfig, setnavConfig] = React.useState([
    {
      subheader: t('Menus'),
      items: Menu
    }
  ]);
  const [navConfigAll, setnavConfigAll] = React.useState([
    {
      subheader: t('Menus'),
      items: Menu
    }
  ]);



  useEffect(() => {
    if (SessionUser.TechnicianType === undefined) {
      return;
    }
    const user_types = SessionUser.TechnicianType.split(',');
    user_types && user_types.forEach((u) => {
      if (parseInt(u) === 26) {
        klima_teknisyeni = true;
      }
    });
  }, [SessionUser]);

  const [UserImageUrl, setUserImageUrl] = useState(!isProduction ? avatar : `https://yetkiliservis.arcelik.com/SchedulingQuota/TechnicianImage/${SessionUser.TechnicianId}.png`);

  useEffect(() => {
    // if (open && onClose) {
    //   onClose();
    // }
    setnavConfig([
      {
        subheader: t('lblMenu'),
        items: Menu
      }
    ]);
    setnavConfigAll([
      {
        subheader: t('Menus'),
        items: Menu
      }
    ]);
    // eslint-disable-next-line
  }, [location.pathname, MenuCount, i18n.language, mailOrbitEnabled]);

  useEffect(() => {
    GetSiriusUserImage();
  }, [SessionUser.TechnicianId]);

  const GetSiriusUserImage = () => {
    const config = {
      responseType: 'blob',
    };

    axios.get(`/FileImportExport/SiriusUserImageDetail/${SessionUser.TechnicianId}`, config)
      .then((response) => {
        // openBlob(response.data, dosya.FileName);
        const fileURL = URL.createObjectURL(response.data);
        setUserImageUrl(fileURL);
      }).catch((error) => {

      });
  }

  const content = (
    <div {...rest} className={clsx(classes.root, className)}>
      <br />
      <Divider className={classes.divider} />
      <nav>
        <div className={classes.search}>
          <div className={classes.searchIcon}>
            <SearchIcon />
          </div>
          <InputBase
            placeholder={t('lblSearchMenu')}
            autoFocus
            value={Search}
            // onKeyUp={(e) => setAnchorEl(e.currentTarget)}
            onChange={(event) => setSearchFind(event)}
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
            inputProps={{ 'aria-label': 'search' }}
          />
        </div>
      </nav>
      <Divider className={classes.divider} />
      <nav className={classes.navigation}>
        {navConfig.map(list =>
          renderNavItems(
            {
              items: list.items,
              subheader: list.subheader,
              pathname: location.pathname,
              key: list.subheader
            },
            klima_teknisyeni
          )
        )}
      </nav>
      <Divider className={classes.divider} />
      <div className={classes.profile}>
        <Avatar
          alt="Person"
          className={classes.avatar}
          src={UserImageUrl}
        />
        <div className={classes.details}>
          <Link
            component={RouterLink}
            to="/profile/1/timeline"
            variant="h5"
            color="textPrimary"
            underline="none"
          >
            {`${SessionUser.FirstName} ${SessionUser.LastName}`}
          </Link>
          <Typography variant="body2">
            {SessionUser.ServiceShopCode}
            {' '}
            {SessionUser.ServiceShopName}
            {' '}
            {SessionUser.TopServiceShopName}
          </Typography>
        </div>
      </div>
    </div>
  );

  const setSearchFind = (event) => {
    setSearch(event.target.value);
    var SearchDataEnd = navConfigAll[0].items.filter((item) => sc(item.title, event.target.value));
    var result = [
      {
        subheader: t('Menus'),
        items: SearchDataEnd
      }
    ];
    setnavConfig(result);

  }




  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{
            paper: classes.mobileDrawer
          }}
          onClose={onClose}
          open={open}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{
            paper: classes.desktopDrawer
          }}
          open={open}
          onClose={onClose}
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
}

NavBar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool
};

export default NavBar;
